import {
    Box,
    Button,
    FormControl,
    Grid,
    MenuItem,
    Select,
    Stack,
    TextField,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import dayjs from 'dayjs';
import axios from "axios";
import { useApiClient } from "../../context/ApiClientContext";
import api from "../../helper/baseApi";

const DetailsEventForm = (id) => {
    const labelWidth = 150;
    const [errors, setErrors] = useState({});

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [isLoading, setLoading] = React.useState(false);

    const {
        apiUrls: { mobileApiUrl },
    } = useApiClient();

    const [inputForm, setInputForm] = useState({
        title: "",
        description: "",
        date: "",
        endDate: "",
        publishedDate: "",
        venue: "",
        status: "",
        createdBy: "",
        createdDate: "",
    });

    // Fetch data when component mounts or id changes
    useEffect(() => {
        if (id) {
            fetchEventData(id);
        } else {
            setLoading(false);
        }
    }, [id]);

    const handleInputChange = (property, event) => {
        const value = event.target.value;
        setInputForm((prevState) => ({
            ...prevState,
            [property]: value,
        }));
    };

    const fetchEventData = async (eventIdParam) => {
        try {
            setLoading(true);
            let actualEventId;

            if (typeof eventIdParam === 'object' && eventIdParam !== null) {
                actualEventId = eventIdParam.eventId || eventIdParam.id || eventIdParam.value;
            } else {
                actualEventId = eventIdParam;
            }

            if (!actualEventId) {
                throw new Error('No valid event ID found');
            }

            // Get employeeId from localStorage
            const employeeId = localStorage.getItem('employeeId');

            const apiUrl = `${mobileApiUrl}event/event-details-portal?eventId=${actualEventId}`;
            const response = await api.get(apiUrl);
            if (response.data) {
                const eventData = response.data.data;
                setInputForm({
                    title: eventData.title || "",
                    description: eventData.description || "",
                    startDate: eventData.eventDate ? dayjs(eventData.eventDate).format('YYYY-MM-DD') : "",
                    endDate: eventData.completedDate ? dayjs(eventData.completedDate).format('YYYY-MM-DD') : "",
                    publishedDate: eventData.publishDate ? dayjs(eventData.publishDate).format('YYYY-MM-DD') : "",
                    venue: eventData.eventVenue || "",
                    status: eventData.status || "",
                    createdBy: eventData.creatorName || "",
                    createdDate: eventData.createdDate ? dayjs(eventData.createdDate).format('YYYY-MM-DD') : "",
                });
            }
        } catch (error) {
            console.error("Error fetching event data:", error);
            toast.error("Error loading event details");
        } finally {
            setLoading(false);
        }
    };

    const renderField = (
        label,
        id,
        type = "text",
        select = false,
        rows,
        options = []
    ) => (
        <Box
            sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: 1,
                mb: 2,
            }}
        >
            <Typography
                sx={{
                    minWidth: { sm: labelWidth },
                    alignSelf: { sm: "center" },
                }}
            >
                {label}
            </Typography>
            <TextField
                id={id}
                type={type}
                select={select}
                InputProps={{
                    readOnly: true,
                }}
                error={!!errors[id]}
                helperText={errors[id]}
                onChange={(e) => handleInputChange(id, e)}
                value={inputForm[id]}
                required
                fullWidth
                size="small"
                variant="outlined"
                multiline
                maxRows={rows}
            >
                {select &&
                    options.map((opt) => (
                        <MenuItem key={opt.value} value={opt.value}>
                            {opt.label}
                        </MenuItem>
                    ))}
            </TextField>
        </Box>
    );
    const submitForm = (message) => {
        const response = message;
        console.log(response);
        toast.success(response);
    };
    const SubmitButton = () => (
        <Stack direction={isMobile ? "column" : "row"}
            spacing={2} mb={5}
            sx={{
                width: isMobile ? '100%' : 'auto',
                alignItems: isMobile ? 'stretch' : 'flex-start'
            }}>
            <Button
                variant="contained"
                size="medium"
                onClick={() => submitForm("Successfully created.")}
                sx={{
                    backgroundColor: "secondary.main",
                    fontWeight: "600",
                    "&:hover": { backgroundColor: "secondary.dark" },
                    mb: 3,
                }}
            >
                Save
            </Button>
        </Stack>
    );

    return (
        <Box sx={{ width: "100%" }}>
            {/* Submit button aligned right */}
            <Box display="flex" justifyContent="flex-end" alignItems="center" mb={2}>
                {/* <SubmitButton /> */}
            </Box>

            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 6 }}>
                <Grid size={{ xs: 12, md: 6 }}>
                    {renderField("Title", "title")}
                    {renderField("Description", "description", "text", false, "4")}
                    {renderField("Start Date", "startDate", "date")}
                    {/* {renderField("End Date", "endDate", "date")} */}
                    {renderField("Published Date", "publishedDate", "date")}
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    {renderField("Venue", "venue")}
                    {renderField("Status", "status", "text", true, 1,[
                        { value: "Open", label: "Open" },
                        { value: "Published", label: "Published" },
                        { value: "Closed", label: "Closed" },
                    ])}
                    {renderField("Created By", "createdBy")}
                    {renderField("Created Date", "createdDate", "date")}
                </Grid>
            </Grid>
        </Box>
    );
};

export default DetailsEventForm;
